import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetSensorsCalibrationResData } from "./GetSensorsCalibrationResData";

const ENDPOINT = "/log_analysis/sensorcalibration";

export class GetSensorsCalibrationCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetSensorsCalibrationReqData = null;

    constructor(params: GetSensorsCalibrationReqData) {
        super();
        this.params = { ...params };
    }

    public async execute(): Promise<GetSensorsCalibrationResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetSensorsCalibrationResData(res);
    }
}

export class GetSensorsCalibrationReqData {
    // FilterInstallations
    installationName: string = null;
    serialNumber: string = null;
    dateStart: Date = null;
    dateEnd: Date = null;

    constructor(installationName: string, serialNumber: string, dateStart: Date, dateEnd: Date) {
        this.installationName = installationName;
        this.serialNumber = serialNumber;
        this.dateStart = dateStart;
        this.dateEnd = dateEnd;
    }
}
